import React, { Fragment } from 'react';
import { connect } from 'dva';
import { Button, Row, Col, Steps } from 'antd';
// import router from 'umi/router';
import Result from '@/components/Result';
// import { routerRedux } from 'dva/router';
// const { Step } = Steps

@connect(({ dispatch }) => ({
  dispatch,
}))
class Complete extends React.PureComponent {
  
  render() {
    const { onContinue, onList, info } = this.props

    const categoryNames = (info.categories || []).map(_ => _.name).join(' / ')
    const extra = (
      <Fragment>
        <div
          style={{
            fontSize: 16,
            color: 'rgba(0, 0, 0, 0.85)',
            fontWeight: '500',
            marginBottom: 20,
          }}
        >
          {info.name}
        </div>
        <Row style={{ marginBottom: 16 }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={12} style={{ lineHeight: '30px' }}>
            <span style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
            套餐类别：
            </span>
            {categoryNames}
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={7} style={{ lineHeight: '30px' }}>
            <span style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
            套餐编码：
            </span>
            {info.orderTemplateVos && info.orderTemplateVos[0] && info.orderTemplateVos[0].code}
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={5}>
            <span style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
            套餐价格：
            </span>
            <span style={{ fontSize: 18, fontWeight: 500 }}>
              {info.price}
            </span>
            &nbsp;元
          </Col>
        </Row>
        {/* <Steps style={{ marginLeft: -42, width: 'calc(100% + 84px)' }} progressDot current={5}>
          <Step
            title={
              <span style={{ fontSize: 14 }}>
                创建预约
              </span>
            }
          />
          <Step
            title={
              <span style={{ fontSize: 14 }}>
                写病历
              </span>
            }
          />
          <Step
            title={
              <span style={{ fontSize: 14 }}>
                诊断
              </span>
            }
          />
          <Step
            title={
              <span style={{ fontSize: 14 }}>
                精神检查
              </span>
            }
          />
          <Step
            title={
              <span style={{ fontSize: 14 }}>
                治疗方案
              </span>
            }
          />
        </Steps> */}
      </Fragment>
    )
    const actions = (
      <Fragment>
        <Button type="primary" onClick={onContinue}>
          继续添加
        </Button>
        <Button onClick={onList}>套餐目录</Button>
      </Fragment>
    );
    return (
      <Result
        type="success"
        title="套餐保存成功"
        extra={extra}
        actions={actions}
        style={{ marginBottom: 40 }}
      />
    );
  }
}

export default Complete;